import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";

import { Card, CardContent, CardHeader } from "@/components/ui/card";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { useCMSStore } from "@/hooks/use-cms-store";

import { useCMSTabContext } from "../cms-tab-context";
import { useGalleryTabContext } from "./gallery-tab-context";

const cmsGalleryTabHeaderFormSchema = z.object({
  title: z.string(),
  description: z.string(),
});

export const GalleryTabHeader = () => {
  const { tabIndex } = useCMSTabContext();
  const { options } = useGalleryTabContext();
  const onUpdate = useCMSStore.use.onUpdateGalleryTabOptions();

  const form = useForm({
    resolver: zodResolver(cmsGalleryTabHeaderFormSchema),
    defaultValues: {
      title: options.title,
      description: options.description,
    },
  });

  useEffect(() => {
    const unsubscribe = form.subscribe({
      formState: { values: true },
      callback: ({ values }) => {
        onUpdate(tabIndex, { ...options, ...values });
      },
    });

    return unsubscribe;
  }, [form, onUpdate, options, tabIndex]);

  return (
    <Card>
      <CardHeader>
        <h4 className="text-lg font-medium leading-none">Header</h4>
      </CardHeader>

      <Form {...form}>
        <CardContent className="space-y-4">
          <FormField
            control={form.control}
            name="title"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Title</FormLabel>
                <FormControl>
                  <Input placeholder="Add a title to your tab" {...field} />
                </FormControl>
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="description"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Description</FormLabel>
                <FormControl>
                  <Textarea
                    placeholder="Add a description to give more context to your tab"
                    {...field}
                  />
                </FormControl>
              </FormItem>
            )}
          />
        </CardContent>
      </Form>
    </Card>
  );
};
